// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__NcFGZ","navlink":"NavBar_navlink__lHC6+","microPic":"NavBar_microPic__jVBkI"};